import { RecurringTemplatesPage } from '@/features/work-items/pages/RecurringTemplatesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/recurrentes')({
  component: RecurringTemplatesPage,
});
